import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import ProActionMoreItem from "./pro-action-more-item.vue";
export default {
  name: "pro-action-more",
  components: {
    ProActionMoreItem
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    moreLeng: {
      type: Number,
      default() {
        return 6;
      }
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    _moreList() {
      return this.data.filter((v, index) => index > 0);
    }
  },
  mounted() {
    // 监听全局点击事件
    document.addEventListener("click", this.handleClickOutside);
  },
  methods: {
    // 处理外部点击逻辑
    handleClickOutside(e) {
      var _this$$refs$triggerRe, _this$$refs$menuRef, _this$$refs$dropdownR;
      if (!this.visible) return;

      // 修复核心：统一获取原生DOM元素（$el）
      const triggerEl = ((_this$$refs$triggerRe = this.$refs.triggerRef) === null || _this$$refs$triggerRe === void 0 ? void 0 : _this$$refs$triggerRe.$el) || this.$refs.triggerRef;
      const menuEl = ((_this$$refs$menuRef = this.$refs.menuRef) === null || _this$$refs$menuRef === void 0 ? void 0 : _this$$refs$menuRef.$el) || this.$refs.menuRef;
      const dropdownEl = ((_this$$refs$dropdownR = this.$refs.dropdownRef) === null || _this$$refs$dropdownR === void 0 ? void 0 : _this$$refs$dropdownR.$el) || this.$refs.dropdownRef;

      // 封装判断逻辑，增加空值保护
      const isElementInTarget = (targetEl, clickEl) => {
        if (!targetEl || !clickEl) return false;
        return targetEl.contains(clickEl);
      };

      // 判断点击是否在下拉框内部
      const isClickInside = isElementInTarget(triggerEl, e.target) || isElementInTarget(menuEl, e.target) || isElementInTarget(dropdownEl, e.target);

      // 额外兼容：iView的Dropdown浮层会被transfer到body下，单独判断浮层DOM
      const popoverEl = document.querySelector(".ivu-dropdown-transfer");
      if (popoverEl && isElementInTarget(popoverEl, e.target)) {
        return;
      }
      if (!isClickInside) {
        this.visible = false;
      }
    }
  },
  beforeDestroy() {
    // 销毁组件时移除监听，避免内存泄漏
    document.removeEventListener("click", this.handleClickOutside);
  }
};